import useBrand from "../hooks/useBrand";

/**
 * Site-wide footer bar. Renders identically on public pages, the login /
 * register screens, and every authenticated admin view — docked at the
 * bottom of whichever layout mounts it. Left side stays bound to the
 * dynamic company / copyright field from settings; right side is the
 * central branding + version stamp sourced from `/settings/public`.
 */
export default function SiteFooter({ variant = "default" }) {
  const { brandName, version } = useBrand();

  // Admin variant sits inside a card-heavy dark shell — use a subtle
  // divider + neutral text so it doesn't compete with the sidebar.
  const wrap = variant === "admin"
    ? "border-t border-black/8 dark:border-white/10 bg-white dark:bg-[#0F172A] px-6 md:px-12 py-4"
    : "bg-[#F5F1EB] px-6 md:px-12 lg:px-20 py-4 border-t border-black/5";

  return (
    <footer className={wrap} data-testid="site-footer">
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-2 text-xs text-neutral-500 dark:text-neutral-400">
        <p data-testid="footer-copyright">
          © {new Date().getFullYear()} {brandName}. All rights reserved.
        </p>
        <p data-testid="footer-tagline">
          Crafted with precision by Brainart Creative Technologies{version ? ` · ${version}` : ""}
        </p>
      </div>
    </footer>
  );
}
